import api from './api';
import type { Evaluation, CreateEvaluationRequest, UpdateEvaluationRequest } from '../types';

export const evaluationsService = {
  async list(filters?: { aoId?: string }): Promise<Evaluation[]> {
    const params = new URLSearchParams();
    if (filters?.aoId) params.append('aoId', filters.aoId);

    const { data } = await api.get<{ success: boolean; data: { evaluations: Evaluation[] } }>(
      `/evaluations?${params.toString()}`
    );
    return data.data.evaluations;
  },

  async getById(id: string): Promise<Evaluation> {
    const { data } = await api.get<{ success: boolean; data: Evaluation }>(`/evaluations/${id}`);
    return data.data;
  },

  async create(evaluationData: CreateEvaluationRequest): Promise<Evaluation> {
    const { data } = await api.post<{ success: boolean; data: { evaluation: Evaluation } }>(
      '/evaluations',
      evaluationData
    );
    return data.data.evaluation;
  },

  async update(id: string, evaluationData: UpdateEvaluationRequest): Promise<Evaluation> {
    const { data } = await api.put<{ success: boolean; data: Evaluation }>(
      `/evaluations/${id}`,
      evaluationData
    );
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/evaluations/${id}`);
  },

  async getByAoId(aoId: string): Promise<Evaluation[]> {
    const { data } = await api.get<{ success: boolean; data: Evaluation[] }>(
      `/appels-offres/${aoId}/evaluations`
    );
    return data.data || [];
  },

  async deleteByAoId(aoId: string): Promise<void> {
    await api.delete(`/appels-offres/${aoId}/evaluations`);
  },

  // Générer des questions d'entretien
  async generateQuestions(id: string): Promise<{ questions: string[] }> {
    const { data } = await api.post<{ success: boolean; data: { questions: string[] } }>(
      `/evaluations/${id}/questions`
    );
    return data.data;
  },
};

export default evaluationsService;
